import { MailOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import Page from '@components/Page/Page'
import { CommunicationKey } from '@models/Communication'
import { useAppSelector } from '@store/hooks'
import { selectSelectedProgram } from '@store/membership/ProgramReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Col, Row } from 'antd'

const EmailNotificationTab = () => {
  const program = useAppSelector(selectSelectedProgram())

  if (!program) {
    return <></>
  }

  return (
    <Page>
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <FormCard
            title="Email subscription accepted"
            icon={<MailOutlined />}
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['emailSubscriptionAccepted']}
            metadata={[
              {
                key: MetadataKey.Communication,
                value: CommunicationKey.EMAIL_SUBSCRIPTION_ACCEPTED,
              },
              {
                key: MetadataKey.CommunicationContext,
                value: { program: program.slug },
              },
            ]}
          />
        </Col>
        <Col span={24}>
          <FormCard
            title="Email subscription payment failed"
            icon={<MailOutlined />}
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['emailSubscriptionPaymentFailed']}
            metadata={[
              {
                key: MetadataKey.Communication,
                value: CommunicationKey.EMAIL_SUBSCRIPTION_PAYMENT_FAILED,
              },
              {
                key: MetadataKey.CommunicationContext,
                value: { program: program.slug },
              },
            ]}
          />
        </Col>
        <Col span={24}>
          <FormCard
            title="Email subscription received"
            icon={<MailOutlined />}
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['emailSubscriptionReceived']}
            metadata={[
              {
                key: MetadataKey.Communication,
                value: CommunicationKey.EMAIL_SUBSCRIPTION_REQUEST_RECEIVED,
              },
              {
                key: MetadataKey.CommunicationContext,
                value: { program: program.slug },
              },
            ]}
          />
        </Col>
        <Col span={24}>
          <FormCard
            title="Email subscription rejected"
            icon={<MailOutlined />}
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['emailSubscriptionRejected']}
            metadata={[
              {
                key: MetadataKey.Communication,
                value: CommunicationKey.EMAIL_SUBSCRIPTION_REJECTED,
              },
              {
                key: MetadataKey.CommunicationContext,
                value: { program: program.slug },
              },
            ]}
          />
        </Col>
        <Col span={24}>
          <FormCard
            title="Email renewal failed"
            icon={<MailOutlined />}
            entity={Entity.membershipProgram}
            action={SBRMAction.Update}
            sections={['emailRenewalFailed']}
            metadata={[
              {
                key: MetadataKey.Communication,
                value: CommunicationKey.EMAIL_SUBSCRIPTION_FAILED_TO_RENEW,
              },
              {
                key: MetadataKey.CommunicationContext,
                value: { program: program.slug },
              },
            ]}
          />
        </Col>
      </Row>
    </Page>
  )
}

export default EmailNotificationTab
